var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"text","aria-label":"Version information, not interactive"}},[_vm._v(" Performo Web: v"+_vm._s(_vm.versions['Performo.Web'])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }